export default __webpack_public_path__ + "static/media/line-v-05.9409b9d1.png";